// React specific
import React, { ChangeEvent, useEffect, useState } from 'react';

// Components
import CopyToClipboardField from '../../components/CopyToClipboardField';
import Loading from '../../components/Loading';
// Translations
import { useIntl } from 'react-intl';
import mailDocumentMessages from './messages';

// Icon
import checkIcon from '../../assets/icons/check-icon-3.svg';
import EnvelopeIcon from '../../assets/icons/envelope-icon.inline.svg';

// Hooks
import { useJsonApi } from '../../services/GlobalStore/GlobalStore';

// Error handling
import { useHandleError } from '../../services/api';

// Ressources
import { generateNewEmailToken } from '../../services/resources/documentUplaodEmailTokens';
import { EmailTokenResponse } from './EmailTokenResponse';

const MailCatcherToken = ({
  claimId,
  token,
}: {
  claimId: string;
  token: string;
}) => {
  const { formatMessage } = useIntl();
  const [handleError] = useHandleError();
  const [emailToken, setEmailToken] = useState<string>('');

  const { data: emailTokenData, loading } = useJsonApi(
    `/claims/${claimId}/documentUploadEmailTokens`,
    {
      cachePolicy: 'no-cache',
    },
    []
  );

  useEffect(() => {
    if (!loading) {
      if (!emailTokenData && claimId) {
        generateNewEmailToken({ claim: { id: claimId } }, token).then(
          (response: EmailTokenResponse) => {
            setEmailToken(response.email);
          },
          (error: Response) => {
            handleError(error);
          }
        );
      } else {
        const response: EmailTokenResponse = emailTokenData?.[0];
        setEmailToken(response?.email);
      }
    }
    // eslint-disable-next-line
  }, [loading, claimId, emailTokenData, token]);

  function handleOnChange(event: ChangeEvent): void {
    setEmailToken(event?.target.value);
  }

  return !emailToken && loading ? (
    <Loading />
  ) : (
    <div className={'mt-30 p-20 bg-primary-05 mb-10 rounded'}>
      <div className="bg-green">
        <CopyToClipboardField
          icon={EnvelopeIcon}
          buttonIcon={checkIcon}
          label={formatMessage(mailDocumentMessages.inputLabelTitle)}
          buttonText={formatMessage(mailDocumentMessages.copyButtonTitle)}
          copiedText={formatMessage(mailDocumentMessages.copiedButtonTitle)}
          inputValue={emailToken}
          onChange={handleOnChange}
        />
      </div>
    </div>
  );
};

export default MailCatcherToken;
